module.exports = __webpack_public_path__ + "img/slide_1.6c84e2ca.jpg";